import React, { ReactNode } from 'react';
import { IObject } from '@utils/defaultTypes';
import { CardProps } from 'antd/lib/card';

import * as S from './styles';

interface ICardStyled extends CardProps {
  children?: ReactNode;
  title?: ReactNode;
  className?: string;
  style?: IObject;
  extra?: ReactNode;
}

const CustomCard: React.FC<ICardStyled> = ({ children, ...rest }) => (
  <S.CardContainer {...rest}>{children}</S.CardContainer>
);

export default CustomCard;
